module.exports = __webpack_public_path__ + "img/partnersKV.d19fd9d4.png";